// @ts-nocheck
import { ButtonPresentationProps } from "@insite/mobius/Button";

import ShoppingCartFill from "@store/Library/Components/Toolkit/Icons/ShoppingCart/ShoppingCartFill";

import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ProductSubscriptionDto } from "@insite/client-framework/Types/ApiModels";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React from "react";

interface AddToCartButtonWithIconProps {
    notes?: string;
    labelOverride?: string;
    extendedStyles?: AddToCartButtonWithIconStyles;
    overrideStyles?: AddToCartButtonWithIconStyles;
    overrideProps?: AddToCartButtonWithIconProps;
    configurationSelection?: SafeDictionary<string>;
    configurationCompleted?: boolean;
    variantSelectionCompleted?: boolean;
    subscription?: ProductSubscriptionDto;
}
export interface AddToCartButtonWithIconStyles {
    button?: ButtonPresentationProps;
}

const addToCartWithIconStyles: AddToCartButtonWithIconStyles = {
    button: {
        icon: {
            src: ShoppingCartFill,
            position: "left",
        },
    },
};

const AddToCartButtonWithIcon: React.FC<AddToCartButtonWithIconProps> = ({
    notes,
    extendedStyles,
    overrideStyles,
    labelOverride,
    configurationCompleted,
    configurationSelection,
    subscription,
    variantSelectionCompleted,
}) => {
    const styles = useExpandProps(addToCartWithIconStyles, extendedStyles, overrideStyles);
    const buttonStyles = styles.button;
    return (
        <ProductAddToCartButton
            labelOverride={labelOverride}
            configurationCompleted={configurationCompleted}
            notes={notes}
            configurationSelection={configurationSelection}
            subscription={subscription}
            variantSelectionCompleted={variantSelectionCompleted}
            extendedStyles={buttonStyles}
            data-test-selector="addProductToCart"
        />
    );
};

export default AddToCartButtonWithIcon;
